// src/lessonAccess.js

// ID podtematów/tematów/quizów, które mają być zablokowane dla ucznia.
// Admin ma zawsze pełny dostęp.
export const lockedSubtopicsForStudents = new Set([
  "1_6_1", // Uzupełniające

  "2_5_1", // Uzupełniające

  // III. Funkcje

  "3_4_1",
  "3_4_2",
  "3_4_3",
  "3_4",

  "3_5_1",
  "3_5_2",
  "3_5_3",
  "3_5",

  "3_6_1",

  "4_4_1",

  // V. Trygonometria

  "5_4_1",
  "5_4_3",

  // VI. Planimetria

  "6_4_1",
  "6_4_3",

  // VII. Geometria analityczna
  "7_5_1",

  // VIII. Stereometria
  "8_1_3",
  "8_1_4",
  "8_1",

  "8_2_2",
  "8_2_3",
  "8_2_4",
  "8_2",

  "8_3_2",
  "8_3_3",
  "8_3",

  "8_4_1",

  // IX. Prawdopodobieństwo i statystyka

  "9_2_3",
  "9_2",


  "9_4_1",


  // X. Dowody matematyczne
  "10_1_1",
  "10_1_2",
  "10_1_3",
  "10_1",

  "10_2_1",
  "10_2_2",
  "10_2_3",
  "10_2",

  "10_3_1",
]);

// ✅ Helper: “czy to jest wkrótce / placeholder dla ucznia?”
export function isLockedForStudents(lessonId) {
  return lockedSubtopicsForStudents.has(String(lessonId || ""));
}

// ✅ Subtelny tekst dla gościa (marketingowo, bez straszenia)
export function getSoonNoteForGuest(lessonId) {
  return isLockedForStudents(lessonId)
    ? "Po rejestracji (wkrótce)"
    : "Dostępne po rejestracji";
}
